import "styles/page.css";

import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import parse from "html-react-parser";
import axios from "axios";

import { handleOpenPdf } from "utils";
import { LinkButton } from "components/buttons";
import { ASSETS_BASE_URL } from "constants";
import useStore from "stores/Store";
import { isEmpty } from "lodash";

function Compliance() {
  const [complianceData, setComplianceData] = useState();
  const { aboutState, setAboutState } = useStore();

  const fetchAboutData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/abouts?pLevel`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );
      const jsonResponse = response.data.data[0];
      setAboutState(jsonResponse);
      setComplianceData(
        jsonResponse?.CorporateGovernance[0].ComplianceAMLStatement[0]
      );
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    if (isEmpty(aboutState)) {
      fetchAboutData();
    } else {
      setComplianceData(
        aboutState?.CorporateGovernance[0].ComplianceAMLStatement[0]
      );
    }
  }, []);

  return (
    <>
      <style type="text/css">
        {`

        @media (min-width: 768px) {
          .compliance-card {
            border-radius: 5px;
            border: 1px solid #D6D6D6;
            background: var(--white, #FFF);
            margin-bottom: 12px;
            padding: 10px;
            min-height: 135px;
          }
        }

         @media (max-width: 767px) {
          .compliance-card {
            border-radius: 5px;
            border: 1px solid #D6D6D6;
            background: var(--white, #FFF);
            margin-bottom: 12px;
            padding: 10px;
            min-height: auto;
          }
        }

          .compliance-card p{
            padding: 0px;
            margin: 0px;

            color: var(--alrajhi-Brand-1000, #000045);
            font-family: "Ping AR + LT";
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%; /* 24px */
            letter-spacing: -0.368px;

            text-align: center;
          }

          .compliance-card-section {
            // margin-left: -15px;
            // margin-right: 15px;
          }

          .spacer {
          height: 80px;}
          
       
        `}
      </style>

      <div className="container page">
        <h1 className="page-title">{complianceData?.title}</h1>
        {complianceData?.description && (
          <p className="page-subtitle">{parse(complianceData?.description)}</p>
        )}

        <div className="compliance-card-section">
          <Row>
            {complianceData?.Ethics?.map((ethic, index) => (
              <Col md={3} key={index}>
                <div className="compliance-card d-flex align-items-center justify-content-center">
                  <p>{parse(ethic?.name)}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>
        <br></br>
        {complianceData?.link_description && (
          <p className="page-subtitle">
            {parse(complianceData?.link_description)}
          </p>
        )}

        <div className="spacer"></div>

        <div className="link-button-row">
          {complianceData?.ExternalLink?.map((item, index) => (
            <LinkButton
              key={index}
              text={item?.title}
              onClick={() => handleOpenPdf(item?.link)}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export default Compliance;
